export function uppercase (value) {
  if (value) {
    return value.toUpperCase()
  }
}

export function lowercase (value) {
  if (value) {
    return value.toLowerCase()
  }
}

export function firstLetterCapitalize (value) {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  }
}
